import { CartItem } from '@/types/pos';

export const InvoiceService = {
    async getInvoiceItems (invoiceId: string): Promise<CartItem[]> {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/invoice/${invoiceId}/items`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
        });

        if (!response.ok) {
            throw new Error('Failed to fetch invoice items');
        }

        const data = await response.json();
        return data.data as CartItem[];
    },
    async getInvoiceById (invoiceId: string): Promise<any> {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/invoice/${invoiceId}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
        });

        if (!response.ok) {
            throw new Error('Failed to fetch invoice');
        }

        const data = await response.json();
        return data.data;
    },
    async updateAdvancedInvoice (invoiceId: string, payload: any): Promise<any> {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/invoice/update/advanced/${invoiceId}`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(payload)
        });

        if (!response.ok) {
            const error = await response.json().catch(() => ({}));
            throw new Error(error.message || 'Failed to update invoice');
        }

        return await response.json();
    }
}